import React, { useEffect } from "react";
import ServiceReview from "../../Services/ServiceReview";
import Divider from "../../Divider";
import Divser from "../../About/Divser";
import Doctorbox from "../../Home/Docterbox";
import NumberInfo from "../../Home/NumberInfo";
import Servicebanner from "../../Services/Servicebanner";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Neurologycon from "./Neurologycon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Neurology() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Neurologycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Neurology Clinic in Vijayanagar</title>
        <meta
          name="description"
          content="We are the Best Neurology Clinic in Vijayanagar and Whitefield. If you are looking for this then feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Neurology Clinic in Whitefield, Best Neurology Clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestneurologyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestneurologyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert neurology services including diagnosis and treatment of neurological disorders such as headaches, epilepsy, stroke, Parkinson’s disease, nerve pain, and coordination disorders with advanced clinical care.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Neurological diagnostics and evaluation",
              "Headache and migraine management",
              "Epilepsy and seizure care",
              "Stroke assessment and rehabilitation",
              "Parkinson’s disease management",
              "Peripheral neuropathy care",
              "Balance and coordination disorder treatment",
            ],
            keywords: [
              "best neurology services in Immadihalli",
              "best neurology services in Whitefield",
              "best neurology services in Bangalore",
              "best neurology services in Kundalahalli",
              "best neurology services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Neurology Clinic in Vijayanagar service sets us apart as a leader
        in Neurology services.Contact us for the Best Neurology Clinic in
        Vijayanagar.
      </h2>
      <Servicebanner name="Neurology" banner={"../photo/dd14.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Neurology;
